module.exports = __webpack_public_path__ + "img/sg_opus_logo.c11f3c5c.jpg";